import AutopayIcon from './AutopayIcon'

export default AutopayIcon
